module.exports = __webpack_public_path__ + "media/components/Sponsors/Projects/Show/Shared/envelope-6b006f33c92974465a37ed199e149fbd.svg";